// Library
import React, { useState } from 'react';
// DatePicker from 'react-date-picker' without styles;
import DatePicker from 'react-date-picker';

// CSS Style for this module
import styles from './DateField.module.scss';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

/**
 * Interface for DateFieldProps props
 */
interface DateFieldProps {
	/**
	 * Custom styles of the field
	 */
	customStyles?: string;
	/**
	 * Default value for edit mode
	 */
	defaultValue?: Date;
	/**
	 * Minimum restrictive date to pick
	 */
	minDate?: Date;
	/**
	 * Maximun restrictive date to pick
	 */
	maxDate?: Date;
	/**
	 * onChange function for keeping track field value
	 * debounce is built in
	 */
	handleChange?: (value: Date) => void;
	/**
	 * Msg to be displayed when the status is error
	 */
	errorMsg?: string;
	/**
	 * Boolean for determining whether this is a required field
	 */
	status?: 'valid' | 'error';
	/** Element identifier selector for test */
	testId?: string;
}

export function DateField({
	customStyles,
	defaultValue,
	minDate,
	maxDate,
	errorMsg = 'Please fill up the field',
	status = 'valid',
	handleChange = () => {
		return;
	},
	testId,
}: DateFieldProps) {
	const [date, setDate] = useState(defaultValue);

	const onChangeValue = (value: Date) => {
		setDate(value);
		handleChange(value);
	};

	return (
		<div className={[styles.container, customStyles].join(' ')}>
			<DatePicker
				calendarAriaLabel="Toggle calendar"
				onChange={(value: Value) => onChangeValue(value as Date)}
				value={date}
				dayPlaceholder="dd"
				monthPlaceholder="mm"
				yearPlaceholder="yyyy"
				clearIcon={null}
				format="dd/MM/y"
				minDate={minDate}
				maxDate={maxDate}
				className={[styles['datepicker'], styles[`datepicker-${status}`]].join(' ')}
				data-testid={testId}
			/>
			<p
				className={[styles['error-msg'], status !== 'error' && styles['error-msg-hide']].join(' ')}
			>
				{errorMsg}
			</p>
		</div>
	);
}
